import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

interface SidebarStore {
  extended: boolean;

  setExtended: (newExtended: boolean) => void;
}

const useSidebarStore = createWithEqualityFn<SidebarStore>((set) => ({
  extended: false,

  setExtended(newExtended: boolean) {
    set(() => ({ extended: newExtended }));
  },
}), shallow);

export default useSidebarStore;
